const bootstrap = require('bootstrap');

export default {
    initialize(bsPopoverObj: any, options: any) {
        return new bootstrap.Popover(bsPopoverObj, options);
    },
    getPopoverElement(bsPopoverObj: any) {
        return bsPopoverObj.tip;
    },
    open(bsPopoverObj: any) {
        bsPopoverObj.show();
    },
    onOpen(bsPopoverObj: any, callback: any) {
        const el = this.getPopoverElement(bsPopoverObj);
        el.addEventListener('show.bs.popover', callback());
    },
    hideAll() {
        const popovers = document.querySelectorAll('.popover');
        popovers.forEach(item => {
            item.remove();
        });
    },
    hide(bsPopoverObj: any) {
        bsPopoverObj.dispose();
    }
};
